/*
 TemplateField.js component
 url match: / or /login
 Displays email id and password field
 with TemplateField button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { formStyles } from '../../Styles/formStyles';

import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import TextField from '@material-ui/core/TextField';


@inject('templateStore')
@observer
class TemplateField extends React.Component {

    

    updateForm = () => {
        this.props.templateStore.updateForm()
    }

    onCancel = () =>{
        this.props.templateStore.resetCurrentField();
        this.props.cancelZoom()
    }

    handleLabelChange = (value, index, fieldId, type) => {
        this.props.templateStore.updateLabel(value, index, fieldId, type)
    }


    render() {
        const { classes } = this.props;
        const { currentField, currentIndex } = this.props.templateStore;
        return (
            currentField._id !== undefined ? <div className={classes.fieldDiv} style={{ width: currentField.style.width, display: currentField.style.display, top: currentField.style.top, left: currentField.style.left }}>
                <p id="fieldLabel" className={classes.fieldLabel}>{currentField.label}</p>
                <div>
                <TextField id="outlined-basic" fullWidth value={currentField.editedLabel !== "" ? currentField.editedLabel : currentField.aiLabel}
                    InputProps={{ disableUnderline: true, classes: { input: classes.textFieldInput, } }}
                    variant="filled"
                    onChange={(event) => this.handleLabelChange(event.target.value, currentIndex, currentField._id, currentField.editedLabel!== "" ? "editedLabel" : "aiLabel")}
                    />
                <TextField style={{marginTop: '1vh'}} id="outlined-basic" fullWidth value={currentField.editedValue !== "" ? currentField.editedValue : currentField.aiValue}
                    InputProps={{ disableUnderline: true, classes: { input: classes.textFieldInput, } }}
                    variant="filled"
                />
                </div>
                <div id="fieldIconContainer" className={classes.fieldIconContainer}>
                    <ReactSVG onClick={(e) => this.onCancel()} src={Images.cancel} beforeInjection={svg => { svg.classList.add(classes.formIcons) }} />
                    <ReactSVG onClick={(e) => this.updateForm()} src={Images.docRight} beforeInjection={svg => { svg.classList.add(classes.formIcons) }} />
                </div>
            </div> : null
        )

    }
}
export default withStyles(formStyles, { withTheme: true })(withRouter(TemplateField));


